import { Button, Stack, Step } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IPackagePreparerStepProps } from './PackagePreparerStep';
import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { useRunBuildsMutation } from '~/lib/api/modules/Builds/hooks/useRunBuildsMutation';

export type IPackagePreparerFinalStepProps = IPackagePreparerStepProps;

export const PackagePreparerFinalStep: React.FC<
  IPackagePreparerFinalStepProps
> = (props) => {
  const { appId, onSuccess, platform, ...other } = props;
  const { t } = useTranslation();
  const runBuildMutation = useRunBuildsMutation();

  const handleRun = (): void => {
    if (runBuildMutation.isLoading) {
      return;
    }

    void runBuildMutation.mutateAsync(
      {
        appId,
        body: { platforms: [platform] },
      },
      {
        onSuccess: onSuccess ? () => onSuccess({ source: 'user' }) : undefined,
      },
    );
  };

  return (
    <Step
      {...other}
      label={t('PackagePreparerFinalStep.name')}
      hasError={!!runBuildMutation.error}
      alwaysExpanded={!other.disabled}
    >
      {runBuildMutation.isError ? (
        <ErrorMessage error={runBuildMutation.error} />
      ) : (
        <Stack gap={4} align="start">
          <Button loading={runBuildMutation.isLoading} onClick={handleRun}>
            {t('PackagePreparerFinalStep.button-label')}
          </Button>
        </Stack>
      )}
    </Step>
  );
};

PackagePreparerFinalStep.displayName = 'Step';
